import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import {sessionStorageEnabled} from '@/utils/sessionStorageUtil';
import {DateTime} from "luxon";

interface State {
    communityCalendarInformation: any;
}

Vue.use(Vuex);

const plugins = [];
if (sessionStorageEnabled()) {
    plugins.push(createPersistedState({ storage: window.sessionStorage, paths: ['communityCalendarInformation'] }));
}

export default new Vuex.Store({
    state: {
        communityCalendarInformation: {},
    },
    mutations: {
        setCommunityCalendarInformation(state: State, item: any) {
            state.communityCalendarInformation = item;
        },
        clearInformation(state: State) {
            state.communityCalendarInformation = {};
        },
    },
    getters: {

    },
    actions: {
    },
    plugins: plugins
});

function checkField(field: any): boolean {
    return Boolean(field && String(field).trim());
}
